var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark",
      staticStyle: { "margin-bottom": "0" },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "collapse navbar-collapse", attrs: { id: "navBar" } },
        [
          _c("ul", { staticClass: "navbar-nav mr-auto" }, [
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/strategy/portfolios/${_vm.workspaceId}/${_vm.strategyId}`,
                      expression:
                        "`/#/strategy/portfolios/${workspaceId}/${strategyId}`",
                    },
                  ],
                  staticClass: "navbar-brand",
                },
                [_vm._v("\n                    Portfolios\n                ")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Projects\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/projects/proposals/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/projects/proposals/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Proposals")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/projects/scheduled/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/projects/scheduled/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Scheduled")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/projects/started/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/projects/started/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Started")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/projects/finished/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/projects/finished/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Finished")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/projects/all/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/projects/all/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("All")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Manage\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/settings/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/settings/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Settings")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/attributes/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/attributes/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Attributes")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/resources/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/resources/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Resources")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/revenues/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/revenues/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Revenues")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/costs/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/costs/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Costs")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/capex/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/capex/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("CAPEX")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/pnls/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/pnls/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("P&Ls")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [
                  _vm._v(
                    "\n                    Business case\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/business-case-templates/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/business-case-templates/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Templates")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/enterprise/metrics/${_vm.workspaceId}/${_vm.strategyId}`,
                        expression:
                          "`/#/enterprise/metrics/${workspaceId}/${strategyId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Metrics")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/enterprise/planning/${_vm.workspaceId}/${_vm.strategyId}`,
                      expression:
                        "`/#/enterprise/planning/${workspaceId}/${strategyId}`",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("Planning")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav" }, [
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Account\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/projects/${_vm.workspaceId}`,
                        expression: "`/#/projects/${workspaceId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Back to workspace")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/#/organizations/users/dashboard" },
                  },
                  [_vm._v("My dashboard")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/organizations/users/account`,
                        expression: "`/#/organizations/users/account`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Manage your account")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/organizations/sessions/close`,
                        expression: "`/organizations/sessions/close`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Sign out")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navBar",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }